export default {"src":"/_next/static/media/wallet.783192ea.svg","height":18,"width":18};